export default __webpack_public_path__ + "assets/home-two-one.474b019cf41743fa1cb38243f0e5aece.png";